import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './Buttons.module.scss'

export default function Buttons({
  align, children, className, ...others
}: props) {
  const wrappedChildren = React.Children.map(children, (child, index) => {
    if (child == null) {
      return null
    }

    const childWithProps = React.cloneElement(child, { ...others })

    return (
      <div key={index} className={styles.item}>
        {childWithProps}
      </div>
    )
  })

  return (
    <div
      className={classNames(
        'Buttons',
        styles.this,
        align && styles[`this---${align}`],
        className,
      )}>
      {wrappedChildren}
    </div>
  )
}

Buttons.propTypes = {
  align: PropTypes.oneOf(['left', 'right']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Buttons/Buttons.js